var _rect, _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgIcSimpleHuman(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 51,
    height: 51,
    viewBox: "0 0 51 51",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 0.208496,
    y: 0.573792,
    width: 50,
    height: 50,
    rx: 25,
    fill: "black"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M17.3805 39.8833C11.7365 39.8233 8.64054 35.5953 8.68854 29.5113C8.71254 23.0793 11.3325 16.7753 15.8765 12.2193C18.9885 9.33129 23.2885 13.6193 20.4085 16.7393C17.0445 20.1113 15.1085 24.7713 15.0885 29.5353C15.1445 33.6433 16.5285 34.1433 20.0885 32.8953C19.1165 30.1033 19.2525 26.6433 20.5205 22.6873C21.2085 20.5433 22.1965 18.1153 24.3285 16.3673C26.8085 14.3353 30.9965 13.7513 33.7085 16.2913C38.1725 20.3513 34.6605 28.7033 31.0805 32.7433C32.9045 32.1233 34.4885 30.6033 35.7325 28.3953C36.5925 26.8513 38.5405 26.2953 40.0845 27.1553C41.6285 28.0153 42.1845 29.9633 41.3245 31.5073C39.9645 33.9513 37.5005 37.1793 33.5045 38.6713C30.3725 39.8393 26.9605 39.5553 24.3085 38.0353C22.2325 39.0753 19.5925 39.9073 17.3765 39.8833H17.3805ZM29.2685 20.9913C27.1245 21.0193 25.8405 26.7393 25.8645 28.9593C27.4045 27.2753 28.5725 25.2473 29.1885 23.0713C29.5045 21.9473 29.4405 21.2233 29.3485 20.9953H29.2685V20.9913Z",
    fill: "white"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIcSimpleHuman);
export default __webpack_public_path__ + "static/media/ic_simple_human.f467a85fb3caf476fe3152c093da79d7.svg";
export { ForwardRef as ReactComponent };